export const API_HOST = import.meta.env.VITE_API_HOST
export const API_ADMIN_HOST = import.meta.env.VITE_ADMIN_HOST
export const PDF_API_HOST = import.meta.env.VITE_API_PDF_URL
export const DADATA_API_HOST = import.meta.env.VITE_DADATA_API_URL
export const DADATA_API_KEY = import.meta.env.VITE_DADATA_API_KEY
